export const UNAUTHENTICATED_ERROR_EVENT = "unauthenticated_error_event";
export const UNAUTHORIZED_ERROR_EVENT = "unauthorized_error_event";

export const endpoint = {
  LOGIN: "/api/login",
};
